import InputReferredModal from "./input-referred-modal.component";

export default InputReferredModal;
